@if (link.route) {
  <div class="list-row" [class.has-children]="link.children">
    <!-- the current page is marked here, unless it's one of the item's children showing (marked there instead) -->
    <a
      mat-list-item
      [routerLink]="route"
      routerLinkActive
      #linkActive="routerLinkActive"
      [class.active-list-item]="linkActive.isActive && !(childActive && expanded)"
      [attr.aria-current]="linkActive.isActive && !(childActive && expanded) ? 'page' : null"
      (click)="handleLinkClick(link)">
      <span class="item-content">
        <mat-icon>{{ link.symbol }}</mat-icon>
        <span class="body2">{{ link.title }}</span>
      </span>
    </a>
    @if (link.children) {
      <button
        mat-icon-button
        type="button"
        class="children-toggle"
        [attr.aria-label]="link.childrenToggleAriaLabel"
        [attr.aria-expanded]="expanded"
        [attr.aria-controls]="childrenId"
        (click)="expanded = !expanded">
        <mat-icon>{{ expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
    }
  </div>
  @if (link.children) {
    <div [id]="childrenId" class="children" [hidden]="!expanded">
      @for (child of link.children; track child.route) {
        <a
          mat-list-item
          [routerLink]="child.route"
          routerLinkActive="active-list-item"
          ariaCurrentWhenActive="page"
          (isActiveChange)="onChildActiveChange(child.route, $event)"
          (click)="handleLinkClick(link)">
          <span class="item-content">
            <span class="body2">{{ child.title }}</span>
          </span>
        </a>
      }
    </div>
  }
} @else {
  <button mat-list-item type="button" class="button-reset" (click)="handleLogout()">
    <span class="item-content">
      <mat-icon>{{ link.symbol }}</mat-icon>
      <span class="body2">{{ link.title }}</span>
    </span>
  </button>
}